/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { withTranslation } from 'react-i18next';
import {
  Dimmer,
  Grid,
  Segment,
} from 'semantic-ui-react';
import { namespaces } from '../../../constants/translation';
import CustomOptions from './CustomOptions';
import { BookingNotePropTypes } from '../../../types';

class NoteEditor extends Component {
  static propTypes = {
    defaultPrivacy: PropTypes.string, // privacy from project default value
    hideCustomOptions: PropTypes.bool, // hides custom options (dropdown and action buttons)
    showInternalPrivacy: PropTypes.bool, // if can show internal option in privacy dropdown
    bookingNote: BookingNotePropTypes, // for edit
    loading: PropTypes.bool, // loading state when adding new note or updating note
    onCancel: PropTypes.func, // cancel edit
    onAdd: PropTypes.func, // create new (send encoded markdown and privacy value)
    onUpdate: PropTypes.func, // edit (send encoded markdown and privacy value)
    t: PropTypes.func,
    settings: PropTypes.shape({
      notesExternalPlaceholder: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
    }),
  };
  constructor(props) {
    super(props);
    const newState = {
      editorPrivacy: this.defaultPrivacyToEditorPrivacy(props.defaultPrivacy, props.showInternalPrivacy),
      editorState: EditorState.createEmpty(),
    };
    if (props.bookingNote && props.bookingNote.note) {
      newState.editorState = this.bookingNoteToEditorState(props.bookingNote);
    }
    this.state = newState;
    this.propUpdateTimeout = null;
  }
  componentWillReceiveProps(nextProps) {
    const bookingNoteChanged = JSON.stringify(nextProps.bookingNote) !== JSON.stringify(this.props.bookingNote);
    const defaultPrivacyChanged = nextProps.defaultPrivacy !== this.props.defaultPrivacy;
    if (bookingNoteChanged || defaultPrivacyChanged) {
      const newState = this.state;
      // when changed to edit mode
      if (JSON.stringify(nextProps.bookingNote) !== JSON.stringify(this.props.bookingNote)) {
        newState.editorState = this.bookingNoteToEditorState(nextProps.bookingNote);
        if (nextProps.bookingNote && nextProps.bookingNote.privacy) {
          newState.editorPrivacy = nextProps.bookingNote.privacy;
          this.setState(newState);
          return; // don't set default privacy below if already setting to the note's privacy
        }
      }
      if (nextProps.defaultPrivacy !== this.state.editorPrivacy) {
        newState.editorPrivacy = this.defaultPrivacyToEditorPrivacy(nextProps.defaultPrivacy, nextProps.showInternalPrivacy);
      }
      this.setState(newState);
    }
  }
  setComponentState(state) {
    return new Promise((resolve) => {
      this.setState((prevState) => {
        const nextState = typeof state === 'function' ? state(prevState) : state;
        return nextState;
      }, () => resolve(this.state));
    });
  }
  getPlaceholder() {
    const { auth, settings, t } = this.props;
    // for agents
    if (auth &&
      auth.companyBranch &&
      auth.companyBranch.isExternal &&
      auth.isDeveloper &&
      !auth.isSuperAdmin &&
      !auth.isHeadquarters &&
      !auth.isBranchLeader &&
      settings && settings.notesExternalPlaceholder) {
      return settings.notesExternalPlaceholder;
    }

    return `${t('Type a note')}...`;
  }
  bookingNoteToMDValue = (bookingNote) => {
    if (bookingNote && bookingNote.note) {
      const bNote = bookingNote.note;
      try {
        const hasNoSpaces = bNote.indexOf(' ') === -1;
        if (hasNoSpaces) {
          return decodeURIComponent(bNote.replace(/\+/g, ' '));
        }
        return decodeURIComponent(bNote);
      } catch (e) {
        return bNote;
      }
    }
    return '';
  }
  bookingNoteToEditorState = (bookingNote) => {
    const mdValue = this.bookingNoteToMDValue(bookingNote);
    if (mdValue) {
      const rawData = markdownToDraft(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE',
        },
        remarkableOptions: {
          enable: {
            inline: 'ins',
          },
        },
      });
      const contentState = convertFromRaw(rawData);
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  }
  defaultPrivacyToEditorPrivacy = (defaultPrivacy, showInternalPrivacy) => {
    if (defaultPrivacy !== '') {
      if (!showInternalPrivacy && defaultPrivacy === 'internal') {
        return 'public';
      }
      return defaultPrivacy;
    }
    return '';
  }
  draftJSToMarkdownWrapper = (rawContentState) => {
    const extendedStyleItems = {
      UNDERLINE: {
        open: function open() {
          return '++';
        },
        close: function close() {
          return '++';
        },
      },
    };
    return draftToMarkdown(rawContentState,
      {
        styleItems: extendedStyleItems,
        preserveNewlines: true,
      },
    );
  }
  escapeLineBreaks = (input) => {
    let newInput = input;

    // TODO Booking Notes
    // console.log(JSON.stringify({ data: newInput }));

    if (newInput.includes('1.') || newInput.includes('- ')) {
      // has list
      // newInput = newInput.replace(/\n\n/g, '\n&nbsp;\n');

      // newInput = newInput.replace(/(-.*?\n!-)/g, '$1\n&nbsp;\n');
      // newInput = newInput.replace(/\n{5,}/g, '\n\n\n\n');
      // newInput = newInput.replace(/\n\n/g, '\n&nbsp;\n');
    } else {
      // fix line breaks '\n\n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\n(?=\n)/g, '\n&nbsp;');
      // fix pasting text with line breaks '\n \n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\n\s(?=\n)/g, '\n&nbsp;');
      // fix line breaks '\r\n\r\n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\r\n\s(?=\n)/g, '\n&nbsp;');
      // fix pasting text with line breaks '\r\n \r\n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\r\n\s(?=\r\n)/g, '\n&nbsp;');
    }

    // newInput = newInput.replace(/^(?![\w-]+\n)(?:\n(?!.*\n))*\n/g, '&nbsp;');
    // newInput = newInput.replace(/^(?!.*-.*\n.*-.*$)\n(?=.*\n.*$)/g, '\n&nbsp;');
    // newInput = newInput.replace(/^-[\w\s]+(\n)+$/g, match => match.replace(/\n/g, '&nbsp;\n'));
    // newInput = newInput.replace(/^[^-].*?(\n)+$/g, match => match.replace(/\n/g, '&nbsp;\n'));
    // newInput = newInput.replace(/(-.*?\n)(?=\n)/g, '$1\n&nbsp;');
    // newInput = newInput.replace(/([^-].*?\n)(?=\n)/g, '$1&nbsp;');

    // console.log(JSON.stringify({ data: newInput }));
    return newInput;
  }
  editorStateToMarkdownEncoded = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    let markdownValue = this.draftJSToMarkdownWrapper(rawContentState);
    markdownValue = this.escapeLineBreaks(markdownValue); // TODO Booking Notes
    return encodeURIComponent(markdownValue);
  };
  isEditorStateIsEmpty = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const textLength = contentState.getPlainText().replace(/\s/g, '').length;
    if (textLength < 1) return true;
    return false;
  };
  isEditorStateUnchanged = (editorState, editorPrivacy, bookingNote) => {
    if (bookingNote && bookingNote.privacy !== editorPrivacy) return false;
    if (bookingNote && bookingNote.note !== '') {
      const noteMDEncoded = this.editorStateToMarkdownEncoded(editorState);
      return bookingNote.note === noteMDEncoded;
    }
    return false;
  }
  handleOnEditorStateChange = (newEditorState) => {
    this.setState({
      editorState: newEditorState,
    }, () => {
      // if hideCustomOptions is true then trigger props onUpdate with debouncer
      if (this.props.hideCustomOptions) {
        if (this.propUpdateTimeout) {
          clearTimeout(this.propUpdateTimeout);
        }
        this.propUpdateTimeout = setTimeout(() => {
          if (this.props.onUpdate) {
            const noteMDEncoded = this.editorStateToMarkdownEncoded(newEditorState);
            if (this.props.onUpdate) this.props.onUpdate(noteMDEncoded, this.state.editorPrivacy);
          }
          this.propUpdateTimeout = null;
        }, 100); // 100ms debounce delay
      }
    });
  };
  handleOnButtonAdd = (e) => {
    e.preventDefault();
    const { editorPrivacy, editorState } = this.state;
    const noteMDEncoded = this.editorStateToMarkdownEncoded(editorState);
    if (this.props.onAdd) this.props.onAdd(noteMDEncoded, editorPrivacy);
  }
  handleOnButtonUpdate = (e) => {
    e.preventDefault();
    const { editorPrivacy, editorState } = this.state;
    const noteMDEncoded = this.editorStateToMarkdownEncoded(editorState);
    if (this.props.onUpdate) this.props.onUpdate(noteMDEncoded, editorPrivacy);
  }
  handleOnButtonCancel = (e) => {
    e.preventDefault();
    if (this.props.onCancel) this.props.onCancel();
  }
  handleOnPrivacyChange = (editorPrivacy) => {
    this.setState({ editorPrivacy });
  };
  resetEditor = async (resetPrivacy = false) => {
    const props = this.props;
    const changedState = {
      editorState: EditorState.createEmpty(),
    };
    if (resetPrivacy) changedState.editorPrivacy = this.defaultPrivacyToEditorPrivacy(props.defaultPrivacy, props.showInternalPrivacy);
    await this.setComponentState((changedState));
  }
  editorToolBar = {
    options: ['inline', 'list', 'emoji'],
    inline: {
      options: ['bold', 'italic', 'underline', 'strikethrough'],
    },
    list: {
      options: ['unordered', 'ordered'],
    },
  }
  render() {
    const { editorState, editorPrivacy } = this.state;
    const { loading, hideCustomOptions, showInternalPrivacy, bookingNote } = this.props;
    return (
      <Segment className="b-note-editor-rdw">
        <Dimmer
          active={loading}
          inverted
          style={{ zIndex: 20 }}
        />
        <Grid>
          <Grid.Row className="no-padding">
            <Grid.Column width={16} className="no-padding">
              <Segment basic>
                <Editor
                  wrapperClassName="b-note-editor-rdw-wrapper"
                  toolbar={this.editorToolBar}
                  toolbarCustomButtons={!hideCustomOptions ? [<CustomOptions
                    hideCustomOptions={hideCustomOptions}
                    isEdit={bookingNote && bookingNote.note !== ''}
                    submitIsDisable={this.isEditorStateIsEmpty(editorState) || this.isEditorStateUnchanged(editorState, editorPrivacy, bookingNote)}
                    privacyValue={this.state.editorPrivacy}
                    onPrivacyChange={this.handleOnPrivacyChange}
                    onButtonAdd={this.handleOnButtonAdd}
                    onButtonCancel={this.handleOnButtonCancel}
                    onButtonUpdate={this.handleOnButtonUpdate}
                    showInternalPrivacy={showInternalPrivacy}
                  />] : undefined}
                  editorState={editorState}
                  onEditorStateChange={this.handleOnEditorStateChange}
                  stripPastedStyles
                  spellCheck
                  placeholder={this.getPlaceholder()}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(NoteEditor);



// WEBPACK FOOTER //
// ./src/components/BookingNote/NoteEditor/NoteEditor.jsx